import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { fromEvent } from 'rxjs';
import { takeWhile, tap, throttleTime } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { DynamicDialogConfig, DynamicDialogRef } from '../../shared';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-update-multiple-authorizations',
    templateUrl: './update-multiple-authorizations.component.html',
    styleUrls: ['./update-multiple-authorizations.component.scss'],
    standalone: false
})
export class UpdateMultipleAuthorizationsComponent
    implements OnInit, AfterViewInit, OnDestroy {
    public userAuthTypes: fromShared.SelectItem[];
    public uniquePayrollItems: fromShared.SelectItem[];
    public serviceItems: fromShared.SelectItem[];
    public authClasses: fromShared.SelectItem[];
    public updateFormGroup: UntypedFormGroup;
    public moment: any;
    @ViewChild('clearBulkUpdates', { read: ElementRef, static: true })
    clearBulkUpdatesButton: ElementRef;
    private active = true;
    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService
    ) {
        this.updateFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(null),
            endDate: new UntypedFormControl(null),
            authType: new UntypedFormControl(null),
            payrollItem: new UntypedFormControl(null),
            serviceItem: new UntypedFormControl(null),
            maxHours: new UntypedFormControl(null),
            authClass: new UntypedFormControl(null),
            ShowSI: new UntypedFormControl(null),
            ShowPI: new UntypedFormControl(null),
            PremiumPayIndicator: new UntypedFormControl(null)
        });
        console.log('UpdateMultipleAuthorizationsComponent:constructor', config);
        this.userAuthTypes = config.data.userAuthTypes;
        this.uniquePayrollItems = config.data.uniquePayrollItems;
        this.serviceItems = config.data.serviceItems;
        this.authClasses = config.data.authClasses;
        this.moment = moment;
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngAfterViewInit(): void {
        // fromEvent(this.clearBulkUpdatesButton.nativeElement, 'click')
        //     .pipe(
        //         takeWhile(x => this.active),
        //         throttleTime(1000),
        //         tap(() =>
        //             this.log.verbose({
        //                 type: 'UserAuthorizationsComponent:clearBulkUpdatesButton:click'
        //             })
        //         )
        //     )
        //     .subscribe(x => {
        //         const controls = this.updateFormGroup.controls;
        //         controls['startDate'].setValue(null);
        //         controls['endDate'].setValue(null);
        //         controls['authType'].setValue(null);
        //         controls['payrollItem'].setValue(null);
        //         controls['serviceItem'].setValue(null);
        //         controls['authClass'].setValue(null);
        //         controls['maxHours'].setValue(null);
        //         controls['ShowSI'].setValue(null);
        //         controls['ShowPI'].setValue(null);
        //         controls['EmployeeAuthStartDate'].setValue(null);
        //         controls['EmployeeAuthEndDate'].setValue(null);
        //         controls['PremiumPayIndicator'].setValue(null);
        //     });
    }

    ngOnInit(): void {}

    clearForm(): void {
        const controls = this.updateFormGroup.controls;
        controls['startDate'].setValue(null);
        controls['endDate'].setValue(null);
        controls['authType'].setValue(null);
        controls['payrollItem'].setValue(null);
        controls['serviceItem'].setValue(null);
        controls['authClass'].setValue(null);
        controls['maxHours'].setValue(null);
        controls['ShowSI'].setValue(null);
        controls['ShowPI'].setValue(null);
        controls['EmployeeAuthStartDate'].setValue(null);
        controls['EmployeeAuthEndDate'].setValue(null);
        controls['PremiumPayIndicator'].setValue(null);
    }
}
